import type { ExclusionAreaObservation } from '../../../types/apiModels'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapSingle } from '../normalize'

export const resolveObservation = async ({
  observationId,
}: {
  observationId: string
}): Promise<ExclusionAreaObservation> => {
  const response = await apiClient.put(
    endpoints.v2.exclusionAreaObservations.resolve(observationId),
  )
  return unwrapSingle<ExclusionAreaObservation>(response)
}
